import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Modal,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";
import clsx from "clsx";

import { useModalStyles } from "./styles";

interface RefreshFunctionModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const RefreshFunctionModal: React.FC<RefreshFunctionModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const classes = useModalStyles();

  return (
    <Modal onClose={onClose} open={open}>
      <Card className={clsx(classes.root)}>
        <CardHeader
          title="Refresh Function"
          classes={{ action: clsx(classes.closeIconAction) }}
          action={<CloseIcon onClick={onClose} />}
        />
        <Divider />
        <CardContent>
          <Typography variant="body1">
            {
              "This is going to affect any Destinations or Sources that use this Function's implementation."
            }
            <br />
            <br />
            <span className={clsx(classes.bold)}>
              Are you sure you want to refresh this function's source code and
              configuration?
            </span>
          </Typography>
        </CardContent>
        <Divider />
        <CardActions className={classes.actions}>
          <Button onClick={onClose}>CANCEL</Button>
          <Button
            className={clsx(classes.deactivateButton)}
            onClick={() => {
              onConfirm();
              onClose();
            }}
            variant="contained"
          >
            REFRESH FUNCTION
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
};
